/**
 * Card portrait URL for orders/units (matches OrderDesign: explicit `image` wins).
 * Explore Unknown synthetic units set `image` to paths that do not follow `/images/<id>.jpg`.
 */

/**
 * @param {{ id?: unknown, image?: unknown } | null | undefined} orderLike
 * @returns {string}
 */
export function getOrderCardImageSrc(orderLike) {
  if (orderLike?.image && typeof orderLike.image === 'string') {
    return orderLike.image;
  }
  return `/images/${orderLike.id}.jpg`;
}

/**
 * Fields copied into client-detected action history entries so thumbnails match battlefield cards.
 * @param {{ id?: unknown, name?: unknown, instanceId?: unknown, image?: unknown } | null | undefined} orderLike
 * @returns {{ id: unknown, name: unknown, instanceId: unknown, image?: string }}
 */
export function pickOrderLogCardFields(orderLike) {
  if (!orderLike || typeof orderLike !== 'object') {
    throw new Error('pickOrderLogCardFields: orderLike must be a non-null object');
  }
  const out = {
    id: orderLike.id,
    name: orderLike.name,
    instanceId: orderLike.instanceId,
  };
  if (orderLike.image && typeof orderLike.image === 'string') {
    out.image = orderLike.image;
  }
  return out;
}
